import { inject } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
export const ZiggySymbol = Symbol();
export const PagePropsPlugin = {
    install: (app) => {
        const page = usePage();
        app.provide(ZiggySymbol, {
            user: () => page.props.value.auth.user,
            company: () => page.props.value.company,
            isAdmin: () => page.props.value.auth.user.admin,
        });
    },
};
export function usePageProps() {
    const plugin = inject(ZiggySymbol);
    if (!plugin) {
        throw new Error(`Could not resolve ${ZiggySymbol.description}`);
    }
    return plugin;
}
